// AI Organization Settings Types
export const BYO_AI_PROVIDERS = [
    'anthropic',
    'google',
    'openai',
    'bedrock',
];
// Providers whose org credential is a bare API key string. Bedrock is excluded:
// it also needs a region, so it carries a config object instead.
export const BYO_AI_API_KEY_PROVIDERS = [
    'anthropic',
    'google',
    'openai',
];
export const isByoAiProvider = (provider) => BYO_AI_PROVIDERS.includes(provider);
// Regions where Bedrock accepts API-key authentication and we can route Claude
// to an in-region or same-geography inference profile.
export const BEDROCK_REGIONS = [
    'ap-northeast-1',
    'ap-northeast-3',
    'eu-central-1',
    'eu-west-1',
    'us-east-1',
    'us-west-2',
];
/**
 * Where Bedrock may process a request. Each value doubles as the cross-region
 * inference profile prefix (`jp.<modelId>`, `us.<modelId>`, ...): the endpoint
 * region only receives the request, the profile decides where inference runs.
 * @ref https://docs.aws.amazon.com/bedrock/latest/userguide/cross-region-inference.html
 */
export const BEDROCK_INFERENCE_GEOGRAPHIES = [
    'jp',
    'us',
    'eu',
    'apac',
    'global',
];
export const JAPAN_BEDROCK_REGIONS = [
    'ap-northeast-1',
    'ap-northeast-3',
];
/**
 * Geographies a credential in `region` may pin inference to, narrowest first —
 * the first entry is the default, so a credential without an explicit choice
 * gets the tightest residency its region supports. Wider entries are an
 * explicit admin opt-out for model availability.
 *
 * Every offered geography must have a profile for EVERY model we ship on
 * Bedrock, because validation is per-credential, not per-model. That excludes
 * `apac` for Japan: AWS documents US, EU, JP and Global profiles for the
 * current Claude generation (e.g. Sonnet 4.5), but no APAC profile — a Tokyo
 * credential widened to `apac` would fail at every prompt.
 */
export const getBedrockInferenceGeographiesForRegion = (region) => {
    if (JAPAN_BEDROCK_REGIONS.includes(region)) {
        return ['jp', 'global'];
    }
    if (region.startsWith('us-'))
        return ['us', 'global'];
    if (region.startsWith('eu-'))
        return ['eu', 'global'];
    if (region.startsWith('ap-'))
        return ['apac', 'global'];
    return ['global'];
};
export const getDefaultBedrockInferenceGeography = (region) => getBedrockInferenceGeographiesForRegion(region)[0];
/**
 * Providers an organization may hold more than one credential for. Bedrock
 * only: it is the one BYO provider whose credential carries a region, so it is
 * the one a multi-region organization needs several of. The other BYO
 * providers stay a single key each in `encrypted_provider_api_keys`.
 */
export const MULTI_CREDENTIAL_AI_PROVIDERS = ['bedrock'];
//# sourceMappingURL=adminTypes.js.map